import CallMadeRoundedIcon from "@mui/icons-material/CallMadeRounded";
import { Box, Typography } from "@mui/material";
import useColors from "../../../../../api/hooks/useColors";
import AssetChip from "../../../../stack/environment/components/EntityDrawer/AssetChip";

export default function CriticalAssetsTooltipContent({
  assetsAtRiskList,
  onAssetClick,
  onViewAllClick,
}) {
  const colors = useColors();

  return (
    <Box display="flex" flexDirection="column" gap={1.5}>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="flex-start"
        gap={1}
      >
        {assetsAtRiskList.map((asset) => (
          <AssetChip
            key={asset.asset_id}
            asset={asset}
            handleClick={() => onAssetClick(asset.asset_id)}
            tooltipTitle=""
          />
        ))}
      </Box>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        gap={0.5}
        onClick={onViewAllClick}
        sx={{
          cursor: "pointer",
          paddingTop: "4px",
        }}
      >
        <Typography
          variant="overline"
          color={colors.primary_main}
          fontWeight="500"
        >
          View All Critical Assets
        </Typography>
        <CallMadeRoundedIcon
          sx={{
            width: "18px",
            height: "16px",
            color: colors.primary_main,
          }}
        />
      </Box>
    </Box>
  );
}
